exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@import url(\"https://fonts.googleapis.com/css?family=Open+Sans:bold,regular|Roboto:bold,regular,light\");\nh1 {\n  font-size: 94px;\n  margin-bottom: 0; }\np {\n  font-size: 28px;\n  color: #e0e0e0; }\n.content-wrap {\n  padding: 30px; }\n.content-wrap button {\n    margin-top: 30px; }\n.logo {\n  background: none; }\n.logo span {\n    font-size: 20px; }\nfooter {\n  position: absolute;\n  bottom: 0;\n  text-align: center;\n  background: #404040;\n  color: #ffffff;\n  width: 100%; }\nfooter span {\n    padding: 20px;\n    display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/error-page/error-page.component.scss
// module id = ../../../../../src/app/shared/components/error-page/error-page.component.scss
// module chunks = main